import styled, { css } from 'styled-components';
import { styled as materialStyles, withStyles } from '@material-ui/styles';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import {
  grey, green, red, orange,
} from '@material-ui/core/colors';

export const StyledFormControl = materialStyles(FormControl)({
  border: 'none',
  display: 'flex',
  flex: '1 0 auto',
  flexFlow: 'column nowrap',
  marginTop: '1em',
  boxSizing: 'border-box',
});

export const StyledRadioGroup = materialStyles(RadioGroup)({
  display: 'flex',
  flex: '1 1 auto',
  flexFlow: 'column nowrap',
});

export const StyledFormLabel = materialStyles(FormLabel)({
  borderTop: '1px solid var(--border-color)',
  color: 'var(--text-color)',
  fontSize: '.9em',
  fontWeight: '600',
  lineHeight: '1.5em',
  padding: '2em 0.5em 0 0.5em',
  minWidth: '97%',
});

export const StyledFormControlLabel = materialStyles(FormControlLabel)((props) => ({
  display: 'flex',

  backgroundColor: props.bgColor || 'inherit',
  border: '1px solid var(--border-color)',
  borderRadius: '3px',
  color: props.color || 'var(--text-color)',
  cursor: 'pointer',

  margin: '0.5em 0.5em 0 0.5em',
  padding: '0.7em 1em',
}));

export const StyledRadio = withStyles({
  root: {
    color: 'var(--text-color)',
    '&$checked': {
      color: grey[50],
    },
  },
  checked: {
    color: grey[50],
  },
})(Radio);

export const LPText = styled.p`
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  color: var(--text-secondary-color);
  font-weight: 300;
  font-size: 1em;
  line-height: 1.6;
  margin: 0;

  ${(props) => props.w400
    && css`
      font-weight: 400;
    `}

  ${(props) => props.m05
    && css`
      margin: 0.5rem;
    `}

  ${(props) => props.marginleft
    && css`
      margin-left: auto;
    `}

  ${(props) => props.marginright
    && css`
      margin-right: auto;
    `}

  ${(props) => props.lowercase
    && css`
      text-transform: lowercase;
    `}

  ${(props) => props.nomargin
    && css`
      margin-bottom: 0;
    `}

  ${(props) => props.padded
    && css`
      padding: 0.5em 1em;
    `}

  ${(props) => props.centered
    && css`
      text-align: center;
    `};

  ${(props) => props.small
    && css`
      font-size: 0.8em;
    `};

  ${(props) => props.description
    && css`
      font-size: 0.8em;
      margin-bottom: 0.5em;
      color: ${grey[400]};
    `};

  ${(props) => props.error
    && css`
      border-radius: 0.25em;
      background-color: ${props.clear ? 'transparent' : red[600]};
      color: ${props.clear ? red[600] : grey[100]};
      padding: 0.5em 1em;
    `}

  ${(props) => props.warning
    && css`
      border-radius: 0.25em;
      padding: 0.5em 1em;
      background-color: ${props.clear ? 'transparent' : orange[600]};
      color: ${props.clear ? orange[600] : grey[100]};
    `}

  ${(props) => props.success
    && css`
      background-color: ${props.clear ? 'transparent' : green[600]};
      border-radius: 0.25em;
      color: ${props.clear ? green[600] : grey[100]};
      padding: 0.5em 1em;
    `}

  ${(props) => props.active
    && css`
      color: var(--brand-color);
    `}
`;
